import React, { Component } from 'react'
import { observer } from 'mobx-react'
import styles from './style.module.less'
import Panel from '@common/Panel'
import mainStore from '@components/Main/store'
import { getMoney } from '@hlj/hlj-utils'
import auth, { STORE_OVERVIEW } from '../auth'
import {
  APPRAISE_LIST_PATH,
  ORDER_PATH,
  INCOME_PATH,
  CUSTOMER_MANAGE_LIST_PATH
} from '@constant'
import { Link } from 'react-router'
import { isRoleService } from '@util'

/** 实时概况 */
@auth(STORE_OVERVIEW)
@observer
export default class extends Component {
  render() {
    const { merchant_comment } = mainStore.merchantInfo
    const {
      todo_order_count, // 待接单
      refund_count, // 退款单
      appoint_count_todo, // 待处理
      appoint_count_today, // 预计今日到店
      sum_balance // 余额
    } = mainStore.shopInfo

    const { three_month_score, bad_rate } = merchant_comment || {}

    const _bad_rate =
      (isNaN(bad_rate * 100) ? 0 : bad_rate * 100).toFixed(0) + '%'

    return (
      <>
        <Panel title="实时概况" contentStyle={{ padding: 0 }}>
          <div className={styles.main}>
            <div className={styles.left}>
              <div className={styles.item}>
                <Link to={`${CUSTOMER_MANAGE_LIST_PATH}?status=1`}>
                  <div className={styles.itemTitle}>待处理</div>
                  <div className={styles.itemValue}>
                    {appoint_count_todo || 0}
                  </div>
                </Link>
              </div>
              <div className={styles.item}>
                <Link to={`${CUSTOMER_MANAGE_LIST_PATH}?status=3`}>
                  <div className={styles.itemTitle}>预计今日到店</div>
                  <div className={styles.itemValue}>
                    {appoint_count_today || 0}
                  </div>
                </Link>
              </div>
              <div className={styles.item} style={{ cursor: 'pointer' }}>
                <Link to={APPRAISE_LIST_PATH}>
                  <div className={styles.itemTitle}>店铺评分</div>
                  <div className={styles.itemValue}>{three_month_score}</div>
                </Link>
              </div>
              <div className={styles.item} style={{ cursor: 'pointer' }}>
                <Link to={APPRAISE_LIST_PATH}>
                  <div className={styles.itemTitle}>差评率</div>
                  <div className={styles.itemValue}>{_bad_rate}</div>
                </Link>
              </div>
            </div>
            <div className={styles.right}>
              <div className={styles.item}>
                <Link to={`${ORDER_PATH}/14`}>
                  <div className={styles.itemTitle}>待接单</div>
                  <div className={styles.itemValue}>
                    {todo_order_count || 0}
                  </div>
                </Link>
              </div>
              <div className={styles.item}>
                <Link to={`${ORDER_PATH}/20`}>
                  <div className={styles.itemTitle}>退款单</div>
                  <div className={styles.itemValue}>{refund_count || 0}</div>
                </Link>
              </div>
              {!isRoleService() && (
                <div className={styles.item}>
                  <Link to={INCOME_PATH}>
                    <div className={styles.itemTitle}>余额</div>
                    <div className={styles.itemValue}>
                      {getMoney(sum_balance)}
                    </div>
                  </Link>
                </div>
              )}
            </div>
          </div>
        </Panel>
      </>
    )
  }
}
